
            <div class="wrapper-reponsive">
                <!-- Start màn 12 -->
                <div class="nav-tab-common">
                    <ul>
                        <li [ngClass]="{'active': item.active}" *ngFor="let item of lstInterviewSheet">
                            <a href="">{{item.InterviewSheetName}}</a>
                        </li>
                    </ul>
                </div>
                <div class="tlt-green-row mt-3">
                 {{'STR_INTERVIEW_SCREEN_NAME' | translate}}
                </div>
                <div class="content-box mt-2 mb-4">
                    <div class="tlt-border mb-3">
                        予約内容確認
                    </div>
                    <p class="p-2">
                        予約内容をご確認ください。
                    </p>
                    <div class="row-input row-input-auto-height p-3 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot">
                                予約日
                            </div>
                            <div class="row mt-2">
                                <div class="col-4">
                                    <label class="custom-radio">男
                                        <input type="radio" name="radio" id="1" checked>
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="col-4">
                                    <label class="custom-radio">女
                                        <input type="radio" name="radio" id="2" checked>
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-3 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot">
                                予約日
                            </div>
                            <p class="p-2 m-0">
                                予約内容をご確認ください。
                            </p>
                            <div class="mt-2">
                                <label class="custom-radio">男
                                    <input type="radio" name="radio" id="1" checked>
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="mt-2">
                                <label class="custom-radio">男
                                    <input type="radio" name="radio" id="1" checked>
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="mt-2">
                                <label class="custom-radio">男
                                    <input type="radio" name="radio" id="1" checked>
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-3 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot">
                                健診コース・オプション
                            </div>
                            <div class="row mt-3">
                                <div class="col-6 pr-0">
                                    <input type="text" class="form-control">
                                </div>
                                <div class="col-6">
                                    修/正
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content-box mt-2 mb-4">
                    <div class="tlt-border mb-3">
                        予約内容確認
                    </div>
                    <p class="p-2">
                        予約内容をご確認ください。
                    </p>
                    <div class="row-input row-input-auto-height p-3 mb-2">
                        <div class="pb-3" style="border-bottom: 1px solid #ccc">
                            <label class="custom-checkbox">
                                利用規約
                                <input type="checkbox">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="row">
                            <div class="col-6 pt-3">
                                <label class="custom-checkbox">
                                    利用規約
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-6 pt-3">
                                <label class="custom-checkbox">
                                    利用規約
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-6 pt-3">
                                <label class="custom-checkbox">
                                    利用規約
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-6 pt-3">
                                <label class="custom-checkbox">
                                    利用規約
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot">
                                健診コース・オプション
                            </div>
                            <div class="pt-3">
                                <input type="text" class="form-control">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content-box mt-2 mb-4">
                    <div class="tlt-border mb-3">
                        予約内容確認
                    </div>
                    <p class="p-2">
                        予約内容をご確認ください。
                    </p>
                    <div class="row-input row-input-auto-height p-3 mb-2">
                        <div class="pb-3" style="border-bottom: 1px solid #ccc">
                            <label class="custom-checkbox">
                                利用規約
                                <input type="checkbox">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="table-radio">
                            <table>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th class="text-center">用規約</th>
                                        <th class="text-center">用規</th>
                                        <th class="text-center">用規</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>用規約</td>
                                        <td class="text-center">
                                            <label class="custom-radio">
                                                <input type="radio" name="radio" id="1" checked>
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                        <td class="text-center">
                                            <label class="custom-radio">
                                                <input type="radio" name="radio" id="1" checked>
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                        <td class="text-center">
                                            <label class="custom-radio">
                                                <input type="radio" name="radio" id="1" checked>
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>用規約</td>
                                        <td class="text-center">
                                            <label class="custom-radio">
                                                <input type="radio" name="radio" id="1" checked>
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                        <td class="text-center">
                                            <label class="custom-radio">
                                                <input type="radio" name="radio" id="1" checked>
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                        <td class="text-center">
                                            <label class="custom-radio">
                                                <input type="radio" name="radio" id="1" checked>
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>用規約規約</td>
                                        <td class="text-center">
                                            <label class="custom-radio">
                                                <input type="radio" name="radio" id="1" checked>
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                        <td class="text-center">
                                            <label class="custom-radio">
                                                <input type="radio" name="radio" id="1" checked>
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                        <td class="text-center">
                                            <label class="custom-radio">
                                                <input type="radio" name="radio" id="1" checked>
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot">
                                健診コース・オプション
                            </div>
                            <div class="pt-3">
                                <input type="text" class="form-control">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content-box mt-2 mb-4" >
                    <div class="tlt-border mb-3">
                        予約内容確認
                    </div>
                    <div class="mt-3">
                        <textarea name="" id="" rows="5" placeholder="健診予約健診予約健診予約健診予約" class="form-control"></textarea>
                    </div>
                </div>
                <div class="text-center">
                    <div class="mb-3">
                        <button class="btn btn-common btn-big btn-bg-green">
                            予約
                        </button>
                    </div>
                </div>
                <div class="fixed-action">
                    <button class="btn-circle-action">
                        登録
                    </button>
                </div>
                <!-- End màn 12 -->
            </div>